import { SplitDirection } from "./index76.js";
function getSubdivisionRatio(ratio, direction = SplitDirection.transverse) {
	const minFactor = Math.min(ratio, 1 - ratio);
	return {
		ratio,
		minFactor,
		maxFactor: 1 - minFactor,
		direction
	};
}
export { getSubdivisionRatio };

//# sourceMappingURL=index74.js.map